module.exports = __webpack_public_path__ + "img/wencai_grey.663d51e9.svg";